// src/components/common/SparkFooter.tsx
import React from 'react';

interface SparkFooterProps {
  /** Optional content inside the footer (e.g., buttons). */
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const SparkFooter: React.FC<SparkFooterProps> = ({
  children,
  className = '',
  style = {},
}) => (
  <div className={`spark-footer ${className}`} style={style}>
    {children}
  </div>
);

export default SparkFooter;
